import { ActionButton, ActionButtonType } from "@octopusdeploy/design-system-components";
import { ProcessType } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { Action, useProjectScopedAnalyticActionDispatch } from "~/analytics/Analytics";
import { isProcessTemplateProcessIdentifier, isDeploymentProcessIdentifier, isRunbookProcessIdentifier } from "~/areas/projects/components/Process/types";
import { PermissionCheck } from "~/components/PermissionCheck";
import { processScopedEditPermission } from "../Process/Common/CommonProcessHelpers";
import { useProcessContext } from "../Process/Contexts/ProcessContext";
import { useProcessQueryStringContext } from "../Process/Contexts/ProcessQueryString/ProcessQueryStringContext";
type AddRunbookStepButtonProps = {
    projectId: string;
};
const AddRunbookStepButton: React.FC<AddRunbookStepButtonProps> = ({ projectId }) => {
    const processQueryStringContext = useProcessQueryStringContext();
    const dispatchAction = useProjectScopedAnalyticActionDispatch(projectId);
    return (<PermissionCheck permission={processScopedEditPermission(ProcessType.Runbook)} project={projectId} wildcard={true}>
            <ActionButton type={ActionButtonType.Secondary} label="Add Step" onClick={() => {
            processQueryStringContext.actions.showProcessStepTemplates();
            dispatchAction("Add Deployment Step", { resource: "Runbook Process", action: Action.Add });
        }}/>
        </PermissionCheck>);
};
AddRunbookStepButton.displayName = "AddRunbookStepButton"
type AddDeploymentsStepButtonProps = {
    projectId: string;
};
const AddDeploymentsStepButton: React.FC<AddDeploymentsStepButtonProps> = ({ projectId }) => {
    const processQueryStringContext = useProcessQueryStringContext();
    const dispatchAction = useProjectScopedAnalyticActionDispatch(projectId);
    return (<PermissionCheck permission={processScopedEditPermission(ProcessType.Deployment)} project={projectId} wildcard={true}>
            <ActionButton type={ActionButtonType.Secondary} label="Add Step" onClick={() => {
            processQueryStringContext.actions.showProcessStepTemplates();
            dispatchAction("Add Deployment Step", { resource: "Deployment Process", action: Action.Add });
        }}/>
        </PermissionCheck>);
};
AddDeploymentsStepButton.displayName = "AddDeploymentsStepButton"
function AddBlueprintsStepButton() {
    const processQueryStringContext = useProcessQueryStringContext();
    return (<ActionButton type={ActionButtonType.Secondary} label="Add Step" onClick={() => {
            processQueryStringContext.actions.showProcessStepTemplates();
        }}/>);
}
const ContextAddStepButton: React.FC = () => {
    const processContext = useProcessContext();
    const processIdentifier = processContext.state.processIdentifier;
    if (isDeploymentProcessIdentifier(processIdentifier)) {
        return <AddDeploymentsStepButton projectId={processIdentifier.projectId}/>;
    }
    if (isRunbookProcessIdentifier(processIdentifier)) {
        return <AddRunbookStepButton projectId={processIdentifier.projectId}/>;
    }
    if (isProcessTemplateProcessIdentifier(processIdentifier)) {
        return <AddBlueprintsStepButton />;
    }
    throw new Error(`Unhandled process identifier ${processIdentifier}`);
};
ContextAddStepButton.displayName = "ContextAddStepButton"
export default ContextAddStepButton;
